var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "#303030"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1405_8635)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -11,
    width: 164,
    height: 48,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-12 -7C-12 -9.20914 -10.2091 -11 -8 -11H148C150.209 -11 152 -9.20914 152 -7V33C152 35.2091 150.209 37 148 37H-8C-10.2091 37 -12 35.2091 -12 33V-7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.5 -7C-11.5 -8.933 -9.933 -10.5 -8 -10.5H148C149.933 -10.5 151.5 -8.933 151.5 -7V33C151.5 34.933 149.933 36.5 148 36.5H-8C-9.933 36.5 -11.5 34.933 -11.5 33V-7Z",
    stroke: "#4A4A4A",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.1336,
    cy: 13.0935,
    rx: 13.1336,
    ry: 13.0935,
    fill: "#FBE7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 7.125H17.4583C17.8341 7.125 18.1944 7.27426 18.4601 7.53993C18.7257 7.80561 18.875 8.16594 18.875 8.54167V18.4583C18.875 18.8341 18.7257 19.1944 18.4601 19.4601C18.1944 19.7257 17.8341 19.875 17.4583 19.875H14.625",
    stroke: "#B02C17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0835 17.0404L14.6252 13.4987L11.0835 9.95703",
    stroke: "#B02C17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 13.5H6.125",
    stroke: "#B02C17",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1405_8635"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -11,
    width: 164,
    height: 48,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.03f5f675bf765cb7570bcb8be8104456.svg";
export { ForwardRef as ReactComponent };